import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  GST_TREATMENT_OPTIONS,
  GstTreatment,
} from '../gst-treatment.constants';

@Component({
  selector: 'app-gst-treatment-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <p-dropdown
      class="pp-gst-select"
      [options]="options"
      optionLabel="label"
      optionValue="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [showClear]="showClear"
      [ngModel]="value"
      (ngModelChange)="onChange($event)"
      appendTo="body"
      styleClass="pp-gst-select__dd">
    </p-dropdown>
  `,
  styles: [
    `
      app-gst-treatment-select {
        display: block;
        width: 100%;
        min-width: 0;
      }
      app-gst-treatment-select .pp-gst-select,
      app-gst-treatment-select .p-dropdown {
        width: 100%;
      }
      app-gst-treatment-select .p-dropdown {
        height: 32px;
        min-height: 32px;
      }
      app-gst-treatment-select .p-dropdown .p-dropdown-label {
        display: flex;
        align-items: center;
        padding-top: 0;
        padding-bottom: 0;
        line-height: 30px;
        font-size: 0.875rem;
      }
      app-gst-treatment-select .p-dropdown.p-disabled {
        opacity: 1;
      }
    `,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GstTreatmentSelectComponent),
      multi: true,
    },
  ],
})
export class GstTreatmentSelectComponent implements ControlValueAccessor {
  @Input() placeholder = 'GST treatment';
  @Input() showClear = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<GstTreatment | null>();

  options = GST_TREATMENT_OPTIONS;
  value: GstTreatment | null = null;

  private onTouched: () => void = () => undefined;
  private onValueChange: (v: GstTreatment | null) => void = () => undefined;

  writeValue(value: GstTreatment | null): void {
    this.value = value ?? null;
  }

  registerOnChange(fn: (v: GstTreatment | null) => void): void {
    this.onValueChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(next: GstTreatment | null) {
    this.value = next;
    this.onValueChange(next);
    this.onTouched();
    this.valueChange.emit(next);
  }
}
